import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * UpdatePlanningRange
 *
 * @private
 */
export const updatePlanningRange = createAsyncThunk<
  // Return type of the payload creator
  string,
  // First argument to the payload creator
  uui.domain.actions.rpc.territory.UpdatePlanningRangeAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/territory/updatePlanningRange', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/territory/updatePlanningRange', {
      category: 'rpc',
      type: 'rpc/territory/updatePlanningRange',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on updatePlanningRange`,
      { tags: ['rpc', 'territory'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `updatePlanningRange call failed`,
      error,
    })
  }
})
